import { RegionCode } from '@wix/ambassador-linguist-web-proxy/types';
import { convertLocaleToLanguage, convertLocaleV2ToLanguage } from './languageLocaleConverter';
export const getSiteLanguages = locales => {
  return (locales || []).reduce((acc, current) => {
    const language = convertLocaleToLanguage(current);
    if (language) {
      if (language.primary) {
        acc.originalLanguage.push(language);
      } else {
        acc.translationLanguages.push(language);
      }
    }
    return acc;
  }, {
    originalLanguage: [],
    translationLanguages: []
  });
};
export const getSiteLanguagesV2 = locales => {
  const siteLanguages = locales.map(convertLocaleV2ToLanguage);
  return {
    // Maybe TODO: unite Language type with OriginalLanguage type and TranslationLanguage type to be one type
    // because they are the same
    originalLanguage: siteLanguages.filter(locale => locale.primary),
    translationLanguages: siteLanguages.filter(locale => !locale.primary)
  };
};

/*
    This function is for DMS use ONLY to support locales.
    In editor (and DM) the language code is expected to be 4 letters when it's locale
 */
export const getDMSiteLanguages = locales => {
  const siteLanguagesRaw = getSiteLanguages(locales);
  const originalLanguage = siteLanguagesRaw.originalLanguage.map(language => {
    return {
      ...language,
      languageCode: language.id,
      regionCode: language.regionCode === RegionCode.UNDEFINED_REGION_CODE ? undefined : language.regionCode
    };
  });
  const translationLanguages = siteLanguagesRaw.translationLanguages.map(language => {
    return {
      ...language,
      languageCode: language.id,
      regionCode: language.regionCode === RegionCode.UNDEFINED_REGION_CODE ? undefined : language.regionCode
    };
  });
  return {
    originalLanguage: (originalLanguage == null ? void 0 : originalLanguage[0]) ?? {},
    translationLanguages
  };
};
//# sourceMappingURL=siteLanguages.js.map